/*
 * @Author: wangsx
 * @Date: 2020-07-29 23:43:30
 * @LastEditTime: 2022-01-11 17:01:24
 * @LastEditors: your name
 * @Description: 存储函数
 */

/**
 * 会话存储-存   -------------------------------------------------------会话存储------------------------------------
 * @param {*} key 键名
 * @param {*} value 值
 */
const sessionSet = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

/**
 * 会话存储-取
 * @param {*} key 键名
 */
const sessionGet = key => {
  const _data = sessionStorage.getItem(key);
  try {
    return JSON.parse(_data);
  } catch (e) {
    return _data;
  }
};

/**
 * 会话存储-删
 * @param {*} key 键名
 */
const sessionDel = key => {
  sessionStorage.removeItem(key);
};

/**
 * 会话存储-删处全部
 */
const sessionClear = () => {
  sessionStorage.clear();
};

/**
 * 永久存储-存  -------------------------------------------------------永久存储-----------------------------------
 * @param {*} key 键名
 * @param {*} value 值
 */
const setStorage = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    if (typeof content === "undefined") {
      content = null;
    }
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 永久存储-取
 * @param {*} key 键名
 */
const getStorage = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 永久存储-删
 * @param {*} key 键名
 */
const removeStorage = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

export {
  sessionSet,
  sessionGet,
  sessionDel,
  sessionClear,
  setStorage,
  getStorage,
  removeStorage
};
